import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import './index.css'
import { router } from './router'

// Nach einem Deploy werden alte, gehashte JS-Chunks entfernt. Ein offener Tab, der dann einen
// bereits gelöschten Lazy-Chunk nachladen will, bekommt einen 404 -> Vite feuert 'vite:preloadError'.
// Statt der generischen Fehlerseite: einmalig frisch laden (mit kurzer Sperre gegen Reload-Schleifen).
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  try {
    const KEY = 'vite:preloadReloadAt';
    const last = Number(sessionStorage.getItem(KEY) || '0');
    if (Date.now() - last > 10000) {
      sessionStorage.setItem(KEY, String(Date.now()));
      window.location.reload();
    }
  } catch {
    window.location.reload();
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
